import React, { Component } from "react";
import '../Configuration.css';
import { Box, Paper, TextField, Button, Stack, Tooltip, Grid, Autocomplete, Typography } from "@mui/material";
import CommonGridHeader, { CommonDeleteButton, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import { ImagePaths } from "../../../Utility/ImagePaths";
import { Colors } from "../../../Styles/Colors";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";
import { localGetItem, localSetItem } from "../../../Utility/Services/CacheProviderService";

class DiagnosisReasonMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedReason: null,
            current_page: 0,
            rowsPerPage: 10,
            showSuccessResponse: false,
            showErrorResponse: false,
            responseMessage: "",
            disableBtn: false,
            reason: "",
            reasonID: null,
            reasonList: [],
            reasonMasterList: []
        }
    }
    componentDidMount = () => {
        this.getGlobalreasonList()
        this.getGlobalreasonMasterList()
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    getGlobalreasonList = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.IP_COMPLAINTS_DATASET + `?global_search=true`)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            reasonList: response.data.data,
                        }, () => {
                            this.LoaderFunction(false)
                        });
                    }
                })
                .catch(error => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === "fail") {
                        this.responseSuccessErrorMessage(error.response.data.message, false);
                    }
                });
        } catch (e) {
            this.LoaderFunction(false)
            this.responseSuccessErrorMessage(e.message, false);
        }
    }

    getGlobalreasonMasterList = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.IP_COMPLAINTS_DATASET_MASTERS)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            reasonMasterList: response.data.data,
                        }, () => {
                            this.LoaderFunction(false)
                        });
                    }
                })
                .catch(error => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === "fail") {
                        this.responseSuccessErrorMessage(error.response.data.message, false);
                    }
                });
        } catch (e) {
            this.LoaderFunction(false)
            this.responseSuccessErrorMessage(e.message, false);
        }
    }

    setreasonList() {
        try {
            RestAPIService.getAll(Serviceurls.IP_COMPLAINTS_DATASET).
                then((response) => {
                    if (response.data.status === "success") {
                        let Array = []
                        response.data.data.forEach((element) => { Array.push(element.reason) })
                        localSetItem("ipComplaintsDataList", JSON.stringify(Array))
                    }
                    else {
                        this.responseSuccessErrorMessage(response.data.message, false)
                    }
                }).catch((error) => {
                    this.responseSuccessErrorMessage(error.message, false)
                })
        }
        catch (e) {
            this.responseSuccessErrorMessage(e.message, false)
        }
    }

    responseSuccessErrorMessage(message, type) {
        this.setState({
            showSuccessResponse: message ? type : false,
            showErrorResponse: message ? !type : false,
            responseMessage: message
        })
    }

    renderTextBox(label, statekey, value, options = []) {
        const { t } = this.props;
        return (
            <div id="eMed_srvConfig_divs" style={{ margin: '1vw' }}>
                <Autocomplete
                    disableClearable
                    value={value ? value : ""}
                    sx={{ width: "29.8vw" }}
                    size="small"
                    options={options?.length != 0 ? options : []}
                    getOptionLabel={option => typeof (option) === "string" ? option : statekey === "reason" ? option?.reason : option?.name}
                    onChange={(event, newValue) => {
                        if (newValue) {
                            if (statekey === "reason") {
                                this.setState({
                                    reason: newValue?.reason,
                                    reasonID: newValue?.id,
                                })
                            }
                        }

                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t(label)}
                            name={statekey}
                            InputProps={{
                                ...params.InputProps
                            }}
                        />
                    )}
                />
            </div>
        )
    }
    handleClear = () => {
        this.setState({
            reason: "",
            selectedReason: null,
        })
    }

    handledelete = (data) => {
        this.setState({
            selectedReason: data ? data : null,
        })
    }

    handleSave = () => {
        const { t } = this.props
        let { reasonID } = this.state;
        let isAvl = true;
        let Message = "";
        if (!reasonID) { isAvl = false; Message = "Fillmandatory" }
        if (isAvl) {
            // api call
            let datas = {
                "admission_reason_id": reasonID ? reasonID : null,
            }
            try {
                this.LoaderFunction(true)
                this.setState({ disableBtn: true })
                RestAPIService.create(datas, Serviceurls.IP_COMPLAINTS_DATASET_MASTERS)
                    .then(response => {
                        if (response.data.status === "success") {
                            this.handleClear();
                            this.getGlobalreasonMasterList();
                            this.setreasonList()
                            this.LoaderFunction(false)
                            this.setState({ disableBtn: false })
                            this.responseSuccessErrorMessage(response.data.message, true);
                        }
                    })
                    .catch(error => {
                        if (error?.response?.data?.status === "fail") {
                            this.LoaderFunction(false)
                            this.setState({ disableBtn: false })
                            this.responseSuccessErrorMessage(error.response.data.message, false);
                        }
                    });
            } catch (e) {
                this.responseSuccessErrorMessage(e.message, false);
            }
        } else {
            this.responseSuccessErrorMessage(t(Message), false)
        }
    }

    msgClose() {
        this.setState({
            showSuccessResponse: false,
            showErrorResponse: false,
            responseMessage: ''
        })
    }

    popupClose() {
        this.setState({ selectedReason: null })
    }
    deletePov() {
        try {
            let data = {
                "id": this.state.selectedReason ? this.state.selectedReason.id : null,
            }
            RestAPIService.delete(Serviceurls.IP_COMPLAINTS_DATASET_MASTERS, data).
                then((response) => {
                    if (response.data.status === "success") {
                        this.responseSuccessErrorMessage(response.data.message, true)
                        this.setState({ selectedReason: null, }, () => {
                            this.getGlobalreasonMasterList()
                            this.setreasonList()
                            this.handleClear()
                        })
                    } else {
                        this.responseSuccessErrorMessage(response.data.message, false)
                    }
                }).catch(error => {
                    this.responseSuccessErrorMessage(error.message, false)
                })
        }
        catch (e) {
            this.responseSuccessErrorMessage(e.message, false)
        }
    }

    render() {
        const { t } = this.props;
        let { rowsPerPage, current_page, reasonMasterList, reason } = this.state;
        const columns = [
            { field: 's.no', headerName: t('SNo'), sortable: false, flex: 0.15, renderCell: (index) => index.api.getRowIndexRelativeToVisibleRows(index.row.id) + 1 },
            {
                field: 'reason', headerName: t('Diagnosis Reason'), sortable: false, flex: 0.65, renderCell: (params) => (
                    <Box component={'div'}>
                        {params?.row?.reason ? params?.row?.reason?.length > 25 ?
                            <Tooltip placement="top" title={params?.row?.reason}><Typography fontSize={'0.9vw'}>{params?.row?.reason?.slice(0, 25) + '...'}</Typography></Tooltip> :
                            <Typography fontSize={'0.9vw'}>{params?.row?.reason}</Typography> : '-'}
                    </Box>
                )
            },
            {
                field: 'actions', headerAlign: 'center', headerName: t('Action'), flex: 0.20, sortable: false, hideable: false, align: "center", renderCell: (params) => {
                    return (
                        <CommonDeleteButton
                            disable={!CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Diagnosis Reason", "SubTab")?.editAccess}
                            size="1.5vw"
                            onClick={() => { this.handledelete(params?.row) }} />
                    )
                }
            }
        ]
        return (
            <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
                <Grid container spacing={3} className="eMed_srvConfig_Box">
                    <Grid item xs={7.6}>
                        <Paper className="eMed_srvConfig_Div" >
                            <DataGrid
                                rows={reasonMasterList}
                                columns={columns}
                                getRowId={(row) => row.id}
                                localeText={{
                                    toolbarColumns: "",
                                    toolbarDensity: "",
                                    toolbarExport: "",
                                    toolbarFilters: "",
                                    toolbarExportPrint: ""
                                }}
                                disableRowSelectionOnClick
                                components={{
                                    Toolbar: CommonGridHeader.CommonToolBar,
                                    NoRowsOverlay: () => {
                                        return (
                                            <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                                {t("NoRecordsFound")}
                                            </Stack>
                                        )
                                    }
                                }}
                                headerHeight={40}
                                rowCount={reasonMasterList.length}
                                pageSizeOptions={[10, 20, 30]}
                                pagination
                                paginationMode="client"
                                paginationModel={{
                                    page: current_page,
                                    pageSize: rowsPerPage
                                }}
                                onPaginationModelChange={(model) => {
                                    this.setState({
                                        current_page: model.page,
                                        rowsPerPage: model.pageSize
                                    })
                                }}
                                loading={this.state.isLoader}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={4.4}>
                        <Paper className="eMed_srvConfig_Div">
                            <div className='eMed_srvConfig_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                                <p className='eMed_srvConfig_rightHead_txt'>{t('Diagnosis Reason')}</p>
                            </div>
                            <div className="eMed_srvConfig_subDiv">
                                {this.renderTextBox('Diagnosis Reason *', "reason", reason, this.state.reasonList)}
                            </div>
                            <Stack spacing={2} direction="row" id='eMed_srvConfig_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
                                <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.handleClear() }}>{t("Clear")}</Button>
                                <Button disabled={this.state.disableBtn ? true : !CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Diagnosis Reason", "SubTab")?.editAccess} variant='contained' size="small" id="eMed_Config_btn" emed_tid="Specializaton_Save_Btn" onClick={() => { this.handleSave() }}>{t("Save")}</Button>
                            </Stack>
                        </Paper>
                    </Grid>
                </Grid>
                {
                    this.state.showSuccessResponse ? <ToastMsg severity={"success"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
                }
                {
                    this.state.showErrorResponse ? <ToastMsg severity={"error"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
                }
                {this.state.selectedReason !== null ? <DeletePopup
                    DeletTitle={`${t("deleteMsg")} ${t("diagnosis reason - ")} ${this.state.selectedReason ? this.state.selectedReason?.reason : "-"} ?`}
                    deleteAlertPopupClose={this.popupClose.bind(this)}
                    removeData={this.deletePov.bind(this)}
                /> : null}
            </Box>
        )
    }
}
export default withTranslation()(DiagnosisReasonMaster);